import React, { useState } from "react";
import {
  Card,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Button,
  Box,
  Slide,
  Dialog,
  IconButton,
  DialogTitle
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./style.scss";
import ManualTesting from "./manualTesting";
import SelectTestType from "./testType";
import SelectBrowser from "./selectBrowser";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import notifier from "../../../../utils/notifier";
import api from "../../../../constants/api";
import TestCases from "./testCases";
import CircularProgress from '@mui/material/CircularProgress';
import LoadingIndicator from "../../../../utils/loading";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const steps = ["test_type", "select_browser", "test_cases"];
const TestManually = ({ diagnostic_id, testCases }) => {
  const [testType, setTestType] = useState("");
  const [selectedBrowsers, setSelectedBrowsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [selectedTestCases, setSelectedTestCases] = useState([]);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [manualTestingData, setManualTestingData] = useState([])
  const currentStep = steps[currentStepIndex];

  const handleClickOpen = () => {
    const savedStep = localStorage.getItem("manualTestingStep");
    const reportsData = localStorage.getItem("reports");
    setOpen(true);
    setTestType("");
    setSelectedBrowsers([]);
    setSelectedTestCases([]);
    setCurrentStepIndex(0);
    if (savedStep === "2" && JSON.parse(reportsData)) {
      setStep(2);
    } else {
      localStorage.removeItem("manualTestingStep");
      localStorage.removeItem("reports")
      setStep(1);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleTestTypeChange = (event) => {
    setTestType(event.target.value);
    setSelectedBrowsers([]);
    setSelectedTestCases([]);
    setCurrentStepIndex(1);
  };
  const handleContinue = () => {
    if (currentStepIndex < steps.length - 1) {
      setCurrentStepIndex((prev) => prev + 1);
    }
    if ((testType === "browser" && selectedBrowsers?.length && currentStep === "test_cases" && selectedTestCases?.length)
      || (testType === "script" && currentStep === "test_cases" && selectedTestCases?.length)) {
      const data = {
        id: diagnostic_id,
        type: testType,
        browsers: selectedBrowsers,
        reports: selectedTestCases
      };
      setLoading(true);
      api.diagnosticHistories.create(data)
        .then((response) => {
          setLoading(false);
          notifier.success(response?.message);
          setManualTestingData(response?.data);
          setStep(2);
          localStorage.setItem("manualTestingStep", "2");
        })
        .catch((error) => {
          setLoading(false);
          console.error("Failed to create diagnostic history:", error);
          notifier.error(error?.message);
        });
    }
  }
  const isContinueDisabled =
    (currentStep === "test_type" && !testType && selectedTestCases.length === 0) ||
    (currentStep === "select_browser" && testType !== "script" && selectedBrowsers.length === 0 && selectedTestCases?.length === 0);
  const renderContent = () => {
    let view = '';
    switch (step) {
      case 1:
        view = (
          <div className="test-manually-container">
            {["select_browser", "test_cases", "test_type"].includes(currentStep) && (
              <SelectTestType
                testType={testType}
                handleTestTypeChange={handleTestTypeChange}
              />
            )}
            {/* Only show browsers if testType is not script */}
            {["select_browser", "test_cases"].includes(currentStep) && testType !== "script" && (
              <SelectBrowser
                selectedBrowsers={selectedBrowsers}
                setSelectedBrowsers={setSelectedBrowsers}
              />
            )}
            {currentStep === "test_cases" && (testType === "script" || selectedBrowsers.length > 0) && (
              <TestCases
                testCases={testCases}
                testType={testType}
                selectedTestCases={selectedTestCases}
                setSelectedTestCases={setSelectedTestCases}
              />
            )}
            <Box textAlign="left" mt={2} className="continue-btn">
              <Button
                variant="contained"
                onClick={handleContinue}
                disabled={isContinueDisabled}
              >
                Continue
              </Button>
            </Box>
          </div>
        );
        break;
      case 2:
        view = (
          <ManualTesting
            historyReports={manualTestingData}
            selectedBrowsers={selectedBrowsers}
            setStep={setStep}
          />
        );
        break;
    }
    return view;
  };
  return (
    <>
      <Button
        variant="contained"
        onClick={handleClickOpen}
        sx={{
          backgroundColor: "#1E1E43",
          color: "#fff",
          textTransform: "none",
          px: 2,
          "&:hover": {
            backgroundColor: "#333",
          },
        }}
      >
        Test Manually
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        PaperProps={{
          style: {
            width: "840px",
            maxWidth: "840px",
            borderRadius: "10px",
          },
        }}
      >
        <LoadingIndicator isloading={loading} />
        <Box className="test-manaual-header">
          {step === 2 &&
            <IconButton title="back" onClick={() => setStep(1)} sx={{
              mr: 1, paddingLeft: '0px',
              justifyContent: 'flex-start',
              paddingLeft: '18px'
            }}>
              <KeyboardBackspaceIcon style={{ color: 'black' }} />
            </IconButton>}
          <DialogTitle className={step === 2 ? "modal-title-2 modal-title" : "modal-title"}>
            Manual Testing
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        {renderContent()}
      </Dialog>
    </>
  );
};
export default TestManually;







